import { Grid, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { groupBy } from 'lodash';

import { IHoliday } from '../types';
import { HolidayCard } from './holiday-card';
import { LoadingScreen } from '@app/components';

interface Props {
  holidays?: IHoliday[];
  loading: boolean;
}

const HolidayList = ({ holidays, loading }: Props) => {
  const months = dayjs.months();

  const groupedHolidays = groupBy(holidays, (holiday) => dayjs(holiday.date).format('MMMM'));
  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <Stack spacing={1} mb={2}>
      {months.map((month) => {
        const filteredHolidays = groupedHolidays[month];

        if (!filteredHolidays) {
          return null;
        }
        return (
          <Stack key={month}>
            <Typography variant="h5" ml={2} mt={1} mb={1}>
              {month}
            </Typography>
            <Grid container spacing={2}>
              {filteredHolidays.map((holiday) => (
                <Grid item xs={12} sm={6} md={6} key={holiday.name}>
                  <HolidayCard holiday={holiday} />
                </Grid>
              ))}
            </Grid>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default HolidayList;
